import { Box, HStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { AccordionActivatorButton } from 'components/accordion/styled';
import { getDesignToken, spacing } from 'styles/constants';

export const SignupAccordionItem = Box;

export const SignupAccordionActivatorButton = AccordionActivatorButton.withConfig({
  padding: 0,
});

export const SignupAccordionListItemContainer = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginBottom: spacing.$6,
});

export const SignupAccordionTitle = withTypography({
  variant: 'copyTwo',
  color: getDesignToken('text-default'),
  m: '$0',
  mt: '$1',
  style: { alignSelf: 'flex-start' },
});

export const ContentContainer = Box;
